module.exports = __webpack_public_path__ + "static/media/velour5C.12d26a77.jpg";